import React from "react";
import { Link } from "react-router-dom";
import {
  AiFillInstagram,
  AiFillLinkedin,
  AiFillBehanceCircle,
} from "react-icons/ai";
import { BsGlobe, BsGithub } from "react-icons/bs";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "./HallTeam.sass";

// import Swiper core and required modules
import SwiperCore, { Pagination } from "swiper";

SwiperCore.use([Pagination]);

const SmartText = ({ text, length = 200 }) => {
  const [showLess, setShowLess] = React.useState(true);

  if (text.length < length) {
    return <p>{text}</p>;
  }

  return (
    <div className="read">
      <p
        className="hteam-description"
        dangerouslySetInnerHTML={{
          __html: showLess ? `${text.slice(0, length)}...` : text,
        }}
      ></p>
      <button className="read-more" onClick={() => setShowLess(!showLess)}>
        &nbsp;{showLess ? "Read More" : "View Less"}
      </button>
    </div>
  );
};

export default function HallTeam() {
  const primaryMembers = [
    {
      name: "JOHN (MEME)",
      image: "/images/josh.png",
      department: "Project Lead",
      description:
        "Meme is the Co-founder of Meme Marketplace and OnlyFrens NFT. With a background in construction management he has led teams to complete some of the largest land development projects throughout the Tri-state area. His interest in entrepreneurship has lead him to create a digital marketing agency specializing in mergers and acquisitions by helping companies create compelling value propositions. His interest in Bitcoin started in late 2013 when he purchased his first Bitcoin using Western Union and Local Bitcoin. His belief in cryptocurrencies as an alternative solution continued to grow with his participation in the Chainlink ICO where he gained a deep understanding of Oracles and Smart Contracts.",
    },
    {
      name: "JOSHUA KEZZER (BRAINS)",
      image: "/images/joshua.png",
      department: "Lead Developer",
      description:
        "Brains is the Lead Developer and Co-founder at Meme Marketplace and here at OnlyFrens. He is responsible for technology and security, ensuring that our launches run smoothly, processing generative art, and most importantly keeping our users happy! He has a strong background in entrepreneurship, has founded multiple companies, and has worked in tech for the past decade. He has extensive experience working as an engineer and VFX director for companies such as Paramount Studios and Columbia Pictures.",
      github: "https://github.com/neurologist",
      instagram: "https://instagram.com/vfxbrain",
      web: "https://forms.gle/Udyu1pE3xWpkoFVw7",
    },
  ];
  const secondaryMembers = [
    {
      name: "Kana (Tokyo)",
      image: "/images/kana.png",
      department: "ART TEAM",
      description:
        "Kana has created the beautiful artwork used for the First Edition Fren Collection. She has been drawing Manga style artwork for over 15 years and frequently works with Japan’s largest Manga Publishers and Anime Studios.",
    },
    {
      name: "Olga (Madrid)",
      image: "/images/olga.png",
      department: "ART TEAM",
      description:
        "Olga specializes in Graphic Design and Illustration with a focus on tattoo design. She has assisted in all the beautiful artwork you see on our website. Her artwork will take center stage once we begin our auctions.",
      behance: "https://www.behance.net/raxarussianroulettem",
      web: "https://tripler.carbonmade.com/",
    },
    {
      name: "Pixel Princess",
      image: "/images/pixel.png",
      department: "ART TEAM",
      description:
        "Pixel Princess created every design and animation for our FrogGod and CyberFrens collections. Her favorite pieces to create are animated pixel scenes which allow her to put her complete talents on full display. We will be auctioning these beautiful pieces off in the future.",
    },
    {
      name: "Ross (TechnoKing)",
      image: "/images/ross.png",
      department: "Marketing Team",
      description:
        "TechnoKing assists with innovative marketing strategies that are interesting and fun. His greatest enemy is anything boring(normies) and he’s always the first to try something different.",
    },
    {
      name: "Mika (Merlin)",
      image: "/images/mika.png",
      department: "Discord Community",
      description:
        "Merlin helps ensure our community on Discord runs smoothly and all users are always up to date. She has experience running multiple NFT Servers across both Ethereum and Solana.",
    },
  ];
  return (
    <div className="hteam">
      <div className="hteam-bg">
        <div className="hteam-container">
          <h2
            style={{
              background: "url('/images/team-title-bg.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          >
            Meet Our team
          </h2>
          <div className="hteam-main">
            {primaryMembers.map((member) => {
              return (
                <div className="hteam-member primary" key={member.name}>
                  <div className="hteam-member main">
                    <div className="hteam-member-image">
                      <img src={member.image} alt="" />
                    </div>
                    <div className="hteam-member-name">{member.name}</div>
                  </div>
                  <div className="hteam-member-text">
                    <h3 className="hteam-department">{member.department}</h3>

                    <p className="hteam-description read-less">
                      {member.description}
                    </p>
                    <SmartText text={member.description} />
                    {(member.web ||
                      member.linkedin ||
                      member.instagram ||
                      member.github ||
                      member.behance) && (
                      <div className="hteam-socials">
                        {member.web && (
                          <a href={member.web}>
                            <BsGlobe />
                          </a>
                        )}
                        {member.linkedin && (
                          <a href={member.linkedin}>
                            <AiFillLinkedin />
                          </a>
                        )}
                        {member.instagram && (
                          <a href={member.instagram}>
                            <AiFillInstagram />
                          </a>
                        )}
                        {member.github && (
                          <a href={member.github}>
                            <BsGithub />
                          </a>
                        )}
                        {member.behance && (
                          <a href={member.behance}>
                            <AiFillBehanceCircle />
                          </a>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
          <div className="hteam-secondary">
            {secondaryMembers.map((member) => {
              return (
                <div className="hteam-member" key={member.name}>
                  <div className="hteam-member-image">
                    <img src={member.image} alt="" />
                  </div>
                  <div className="hteam-member-name">{member.name}</div>

                  <h3 className="hteam-department">{member.department}</h3>
                  <div className="hteam-socials-secondary">
                    {member.web && (
                      <a href={member.web}>
                        <BsGlobe />
                      </a>
                    )}
                    {member.linkedin && (
                      <a href={member.linkedin}>
                        <AiFillLinkedin />
                      </a>
                    )}
                    {member.instagram && (
                      <a href={member.instagram}>
                        <AiFillInstagram />
                      </a>
                    )}
                    {member.github && (
                      <a href={member.github}>
                        <BsGithub />
                      </a>
                    )}
                    {member.behance && (
                      <a href={member.behance}>
                        <AiFillBehanceCircle />
                      </a>
                    )}
                  </div>
                  <p className="hteam-description">{member.description}</p>
                </div>
              );
            })}
          </div>
        </div>
        <Swiper
          slidesPerView={1.45}
          spaceBetween={30}
          centeredSlides={true}
          className="mySwiper"
          loop={true}
        >
          {secondaryMembers.map((member) => {
            return (
              <SwiperSlide key={member.name}>
                <div className="hteam-member primary">
                  <div className="hteam-member main">
                    <div className="hteam-member-image">
                      <img src={member.image} alt="" />
                    </div>
                    <div className="hteam-member-name">{member.name}</div>
                  </div>
                  <div className="hteam-member-text">
                    <h3 className="hteam-department">{member.department}</h3>
                    <p className="hteam-description">{member.description}</p>
                    {(member.web || member.linkedin || member.instagram) && (
                      <div className="hteam-socials">
                        {member.web && (
                          <a href={member.web}>
                            <BsGlobe />
                          </a>
                        )}
                        {member.linkedin && (
                          <a href={member.linkedin}>
                            <AiFillLinkedin />
                          </a>
                        )}
                        {member.instagram && (
                          <a href={member.instagram}>
                            <AiFillInstagram />
                          </a>
                        )}
                        {member.github && (
                          <a href={member.github}>
                            <BsGithub />
                          </a>
                        )}
                        {member.behance && (
                          <a href={member.behance}>
                            <AiFillBehanceCircle />
                          </a>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
        <div className="hteam-logo">
          <div className="hteam-logo-img">
            <Link to="/">
              <img src="/images/logo.png" alt="logo" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
